(function($, undefined) {
	'use strict';

	var init = function() {
		$('.stool-shared-popup-btn[data-id="share-popup"]').click(loadAddThis);
	};

	function loadAddThis() {
		var btn = $(this);
		var popup = $('.stool-shared-popup[data-id="share-popup"]');

		popup.find('.init-addthis').addClass('addthis_inline_share_toolbox_ueeu share-popup__share');

		addthis.init();
		if(typeof addthis !== 'undefined') { 
			addthis.layers.refresh(); 
		}
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
